import { Grid, Typography } from '@material-ui/core';
import Spinner from '@material-ui/core/CircularProgress';
import { WithStyles } from '@material-ui/styles';
import React from 'react';
import styles from './styles';
import config from '../../config';
import { useGetSeamWifiThermostat } from '../../hooks/useGetSeamWifiThermostat';

type Props = WithStyles<typeof styles> & {
  wifiThermostatSerial: string | null;
};

const WifiThermostatPanel: React.FC<Props> = (props) => {
  const {
    classes,
    wifiThermostatSerial,
  } = props;
  const { data: wifiThermostatDetails, isLoading } = useGetSeamWifiThermostat(wifiThermostatSerial);

  return (
    <Grid item xs={12} sm={12}>
      {isLoading && (
        <div className={classes.progressWrapper}>
          <Spinner className={classes.progress} />
        </div>
      )}
      {!isLoading && wifiThermostatDetails && (
        <div className={classes.smartLockContainer}>
          <iframe
            title="Smart Lock detail"
            className={classes.iframe}
            src={`${config.INSTALL_TOOL_URL}/#/public/smart-lock?device_id=${wifiThermostatSerial}&seamToken=${wifiThermostatDetails?.token.token}&theme=parent`}
            width="100%"
            height="100%"
          />
        </div>
      )}
      {!isLoading && !wifiThermostatDetails && (
        <Typography variant="h6">
          No WiFi thermostat is configured for this property.
        </Typography>
      )}
    </Grid>
  );
};

export default React.memo(WifiThermostatPanel);
